import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData, { GAME_IMAGES_KEY } from '../gameData';
import TitleScreenBase from './TitleScreenBase';
import { gametypes } from '../GameConfig';

export default class TitleOddEvenScreen extends TitleScreenBase {
  init() {
    super.init();

    this.lblSubtitle = null;
  }

  create() {
    super.create();

    if (ABCyaLib.Environment.instance.gameConfig.gametype === gametypes.both) {
      this.lblSubtitle = ABCyaPhaser.Text.addText(this.scale.width / 2,this.titleHeader.y + (this.titleHeader.getBounds().height * this.titleHeader.scaleX) + 90, '62pt', 0xffffff, FontKeys._cf_samurai_bobregular, 'ODD OR EVEN', this, true).setOrigin(0.5, 0);
      this.children.moveBelow(this.lblSubtitle, this.btnContainer);
      this.btnContainer.y = this.lblSubtitle.y + 15;
    }
    else {
      this.btnContainer.y = this.titleHeader.y + (this.titleHeader.getBounds().height * this.titleHeader.scaleX) + 105;

      this.titleStamp.setFrame(ABCyaLib.Environment.instance.gameConfig.gametype === gametypes.odd ? 'Subtitle_Odds' : 'Subtitle_Evens');
    }
  }

  createButtonContainer() {
    super.createButtonContainer();

    const buttons = gameData.PLAY_BUTTONS;
    const len = buttons.length;
    let curX = 0;
    for (let i = 0; i < len; i++) {
      const item = ABCyaPhaser.Images.addImage(curX, 0, `Btn${buttons[i]}`, this.btnContainer, GAME_IMAGES_KEY).setOrigin(0)
        .setInteractive();
      item.optionID = buttons[i];
      if (ABCyaLib.Environment.instance.gameConfig.senderID) item.optionID = ABCyaLib.Environment.instance.gameConfig.senderID;
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickOptionButton(item));
      this.btnOptions.push(item);
      curX += item.width + 80;
    }

    // const item = ABCyaPhaser.Images.addImage(0, 100, 'BtnPlay', this.btnContainer, GAME_IMAGES_KEY).setOrigin(0)
    //   .setInteractive();
  }
}